// extracted by mini-css-extract-plugin
export default {"sub_categories":"SubCategories_sub_categories__wKhQW"};